<template>
  <div class="green-background">
    <NavBar></NavBar>
    <MainSlider></MainSlider>
    <LinesOfActivity></LinesOfActivity> 
    <section class="section section-3 pb-0">
          <div class="container">
            <div class="row">
              <TrainingServices></TrainingServices>
              <ContactUs></ContactUs>
            </div>
          </div>
    </section>
    <Footer></Footer>
    <go-top></go-top>
  </div>
</template>

<script>
  import NavBar from '@/components/shared/NavBar.vue';
  import MainSlider from '@/components/MainSlider.vue';
  import LinesOfActivity from '@/components/LinesOfActivity.vue';
  import TrainingServices from '@/components/TrainingServices.vue';
  import ContactUs from '@/components/ContactUs.vue';
  import Footer from '@/components/shared/Footer.vue';
  import GoTop from '@inotom/vue-go-top';


  export default {
    name: 'App',
    components: {
      NavBar,
      MainSlider,
      LinesOfActivity,
      TrainingServices,
      ContactUs,
      Footer,
      GoTop
    }
  }
</script>

<style>

</style>